// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.add-client__phone-code .sk-select__list {\n  max-height: 75px;\n}\n", ""]);
// Exports
module.exports = exports;
